import React from "react";
import AccountLinkingPricingExample, { PricingData } from "../../../dialogs/enable-paid-features/AccountLinking";
import MultiTenancyPricingCard, { MultiTenancyConfig } from "../../../dialogs/enable-paid-features/MultiTenancy";
import AdditionalUsers, { AdditionalUsersConfig } from "../../../dialogs/enable-paid-features/AdditionalUsers";
import { LicenseKeyFeaturesList } from "../../../../api/st/features/get";

export const clientSideOnlyFeatureList: LicenseKeyFeaturesList = [
    {
        featureId: "security",
        featureName: "Attack protection suite",
        minVersionXY: "9.0"
    },
    {
        featureId: "oauth",
        featureName: "Unified login and M2M Auth",
        minVersionXY: "9.0"
    }
];
export const featureIDToPricingConfig = {
    account_linking: {
        hasDialog: true,
        dialog: AccountLinkingPricingExample,
        dialogConfig: [
            {
                mauRange: "1 - 4,999",
                price: "$100 / month"
            },
            {
                mauRange: "5,000",
                calculation: "($0.02 + $0.005) * 5000",
                price: "$125 / month"
            },
            {
                mauRange: "7,000",
                calculation: "($0.02 + $0.005) * 7000",
                price: "$175 / month"
            }
        ] as PricingData[],
        pricing: {
            type: "FIXED",
            value: "0.005",
            minimumBilling: "100",
            unit: "MAU",
            text: "$0.005 / MAU"
        },
        type: "ACCOUNT_LINKING"
    },
    multi_tenancy: {
        hasDialog: true,
        dialog: MultiTenancyPricingCard,
        dialogConfig: {
            pricingSections: [
                {
                    header: "Email password, Social, Passwordless login",
                    pricingDetails: [
                        {
                            highlight: { text: "Less than 5 users / tenant", color: "grey" },
                            description: (
                                <span>
                                    Free for 25 tenants, <span className="multitenancy-price-highlight">$2</span> /
                                    tenant / month after that.
                                </span>
                            )
                        },
                        {
                            highlight: { text: "5 or more users / tenant", color: "grey" },
                            description: (
                                <span>
                                    <span className="multitenancy-price-highlight">$5</span> / tenant / month
                                </span>
                            )
                        }
                    ]
                },

                {
                    pricingDetails: [
                        {
                            highlight: { text: "Enterprise SSO", color: "yellow" },
                            description: (
                                <span>
                                    <span className="multitenancy-price-highlight">$50</span> / tenant / month
                                </span>
                            )
                        }
                    ]
                },

                {
                    pricingDetails: [
                        {
                            highlight: { text: "Additional App/Env.", color: "yellow" },
                            description: (
                                <span>
                                    <span className="multitenancy-price-highlight">$50</span> / app / month
                                </span>
                            )
                        }
                    ]
                }
            ],

            link: { text: "See pricing example", url: "/pricing" }
        } as MultiTenancyConfig,
        pricing: {
            type: "INFO",
            text: "See info"
        },
        type: "MULTI_TENANCY"
    },
    dashboard_login: {
        hasDialog: true,
        dialog: AdditionalUsers,
        dialogConfig: {
            numberOfFreeUsers: 3
        } as AdditionalUsersConfig,
        pricing: {
            type: "FIXED",
            value: "20",
            text: "$20 / user / month",
            unit: "user/month"
        },
        type: "DASHBOARD_LOGIN"
    },

    mfa: {
        hasDialog: false,
        pricing: {
            type: "FIXED",
            value: "0.01",
            minimumBilling: "100",
            unit: "MAU",
            text: "$0.01 / MAU"
        },
        type: "MFA"
    },
    security: {
        hasDialog: false,
        pricing: {
            type: "CUSTOM",
            text: "Contact Us",
            mail: "support@supertokens.com"
        },
        type: "ATTACK_PROTECTION_SUITE"
    },
    oauth: {
        hasDialog: false,
        pricing: {
            type: "CUSTOM",
            text: "Contact Us",
            mail: "support@supertokens.com"
        },
        type: "UNIFIED_LOGIN_AND_M2M"
    }
} as const;
